<template>
    <DxDataGrid :data-source="dsIndemnizatii" ref="dataGridRef" :allow-column-reordering="false" :allow-column-resizing="true" :column-auto-width="false"
        :show-borders="true" key-expr="Id">
        <DxSelection mode="single" />
        <DxFilterRow :visible="false" />
        <DxPaging :page-size="10" :page-index="0" />
        <DxLoadPanel :enabled="true" :indicator-src="'reload6.gif'" />
        <DxSorting mode="multiple" />
        <DxSearchPanel :visible="true" :width="240" placeholder='Cauta ...'></DxSearchPanel>
        <DxEditing :allow-updating="true" :allow-deleting="true" mode="popup">
            <DxPopup :closeOnOutsideClick="false" :showCloseButton="false" width="420" height="470" :show-title="true" title-template="editTitle">
                <DxToolbarItem toolbar="bottom" widget="dxButton" location="center" :options="saveButtonOptions" />
                <DxToolbarItem toolbar="bottom" widget="dxButton" location="center" :options="dangerButtonOptions" />
            </DxPopup>
            <DxFormGrid :col-count="2">
                <DxItem data-field="cod" :editor-options="{ height: 50 }"/>
                <DxItem data-field="name" :editor-options="{ height: 50 }"/>
                <DxItem data-field="procent" editor-type="dxNumberBox" :editor-options="numberBoxProcentOptions"/>
                <DxItem 
                    data-field="prevMo" 
                    editor-type="dxSelectBox"
                    :editor-options="{ 
                        items: monthOptions, 
                        displayExpr: 'text', 
                        valueExpr: 'id',
                        placeholder: 'Selectati luna...',
                        height: 50
                    }"
                />
                <DxItem data-field="maxDays" editor-type="dxNumberBox" :editor-options="numberBoxOptions"/>
                <DxItem 
                    data-field="fond" 
                    editor-type="dxSelectBox"
                    :editor-options="{ 
                        items: fondOptions, 
                        displayExpr: 'text', 
                        valueExpr: 'id',
                        placeholder: 'Selectati fondul...',
                        height: 50
                    }"
                />
                <DxItem data-field="Grup" :editor-options="{ height: 50 }"/>
                <DxItem data-field="Cod Grup" :editor-options="{ height: 50 }"/>
            </DxFormGrid>
        </DxEditing>
        <template #editTitle>
            <div style="background-color:#ff2c21; font-size:15px; color:white; font-weight:bold; padding:10px 0 10px 20px; width:100%;">
                Editare Indemnizatie
            </div>
        </template>

        <DxColumn data-field="cod" caption="Cod"/>
        <DxColumn data-field="name" caption="Nume"/>
        <DxColumn data-field="procent" caption="Procent"/>
        <DxColumn data-field="prevMo" caption="Luna Precedenta"/>
        <DxColumn data-field="maxDays" caption="NrMaximDeZile"/>
        <DxColumn data-field="fond" caption="Fond" cell-template="fondTemplate"/>
        <DxColumn data-field="Grup" caption="Grup"/>
        <DxColumn data-field="GrupCod" caption="Cod Grup" :visible="false"/>
        <template #fondTemplate="{ data }">
            <div v-if="data.value==='F'">FAAMBP</div>
            <div v-if="data.value==='B'">BASS/FNUASS</div>
        </template>

        <DxToolbar>
            <DxItem location="after" name="searchPanel"/>
            <DxItem>
                <template #default>
                    <DxButton icon="add" type="success" @click="onAddClick" />
                </template>
            </DxItem>
            <DxItem>
                <template #default>
                    <DxButton icon="refresh" @click="onRefreshClick" />
                </template>
            </DxItem>
        </DxToolbar>
    </DxDataGrid>
    <DxPopupAdd :visible="addPopupVisible" :show-title="true" width="420" height="470">
        <template #title>
            <div style="background-color: #ff2c21; font-size: 15px; color: white; font-weight: bold;  padding: 10px; padding-left: 20px; ">
                Adăugare Indemnizatie 
            </div>
        </template>
        <DxForm :col-count="2" :data-dource="newIndemnizatie">
            <DxSimpleItem data-field="Cod">
                <template #default>
                    <DxTextArea :value="newIndemnizatie.cod" @value-changed="onCodValueChanged" height="50px"/>
                </template>
            </DxSimpleItem>
            <DxSimpleItem data-field="Nume">
                <template #default>
                    <DxTextArea :value="newIndemnizatie.name" @value-changed="onNumeValueChanged" height="50px"/>
                </template>
            </DxSimpleItem>
            <DxSimpleItem data-field="Procent(%)">
                <template #default>
                    <DxNumberBox :min="0" :step="1" :max="100" :show-spin-buttons="true" :show-clear-button="true" :value="newIndemnizatie.procent" @value-changed="onProcentValueChanged" height="50px"/>
                </template>
            </DxSimpleItem>
            <DxSimpleItem data-field="Luna Precedenta">
                <template #default>
                    <DxSelectBox :items="monthOptions"
                                display-expr="text"
                                value-expr="id"
                                :value="newIndemnizatie.prevMo"
                                @value-changed="onMonthValueChanged"
                                height="50px"/>
                </template>
            </DxSimpleItem>
            <DxSimpleItem data-field="Numar de Zile">
                <template #default>
                    <DxNumberBox :min="0" :step="1" :show-spin-buttons="true" :show-clear-button="true" :value="newIndemnizatie.maxDays" @value-changed="onMaxDaysValueChanged" height="50px"/>
                </template>
            </DxSimpleItem>
            <DxSimpleItem data-field="Fond">
                <template #default>
                    <DxSelectBox :items="fondOptions"
                                display-expr="text"
                                value-expr="id"
                                :value="newIndemnizatie.fond"
                                @value-changed="onFondValueChanged"
                                height="50px"/>
                </template>
            </DxSimpleItem>
            <DxSimpleItem data-field="Grup">
                <template #default>
                    <DxTextArea :value="newIndemnizatie.Grup" @value-changed="onGrupValueChanged" height="50px"/>
                </template>
            </DxSimpleItem>
            <DxSimpleItem data-field="Cod Grup">
                <template #default>
                    <DxTextArea :value="newIndemnizatie.GrupCod" @value-changed="onGrupCodValueChanged" height="50px"/>
                </template>
            </DxSimpleItem>
        </DxForm>
        <DxToolbarItem widget="dxButton" toolbar="bottom" location="center" :options="addButtonOptions"/>
        <DxToolbarItem widget="dxButton" toolbar="bottom" location="center" :options="closeButtonOptions"/>
    </DxPopupAdd>
</template>
<script lang="ts">
    import {
        DxColumn,
        DxDataGrid,
        DxFilterRow,
        DxLoadPanel,
        DxPaging,
        DxSelection,
        DxSorting,
        DxStateStoring,
        DxToolbar,
        DxEditing,
        DxPopup,
        DxItem,
        DxItem as DxFormItem,
        DxForm as DxFormGrid,
        DxValidationRule,
        DxRequiredRule,
        DxSearchPanel,
    } from 'devextreme-vue/data-grid';
    import DxDateBox from 'devextreme-vue/date-box';
    import { DxCheckBox } from 'devextreme-vue/check-box';
    import DxTextArea from 'devextreme-vue/text-area';
    import AppSetting from '@/settings/appSettings';
    import { defineComponent, ref } from 'vue';
    import DataSource from 'devextreme/data/data_source';
    import { DxButton } from 'devextreme-vue/button';
    import notify from 'devextreme/ui/notify';
    import { DxForm, DxSimpleItem } from "devextreme-vue/form"
    import DxPopupAdd from 'devextreme-vue/popup'
    import { DxToolbarItem } from 'devextreme-vue/popup';
    import { DxNumberBox } from 'devextreme-vue';
    import { DxSelectBox } from 'devextreme-vue/select-box';
    import PER_Sicknesses from '@/services/PER/PER_Sicknesses';

    export default defineComponent({
        components: {
            DxColumn,
            DxDataGrid,
            DxFilterRow,
            DxLoadPanel,
            DxPaging,
            DxSelection,
            DxSorting,
            DxStateStoring,
            DxToolbar,
            DxEditing,
            DxValidationRule,
            DxRequiredRule,
            DxItem,
            DxButton,
            DxSearchPanel,
            DxForm,
            DxPopupAdd,
            DxSimpleItem,
            DxTextArea,
            DxCheckBox,
            DxToolbarItem,
            DxPopup,
            DxFormGrid,
            DxFormItem,
            DxDateBox,
            DxNumberBox,
            DxSelectBox
        },
        data() {
            return {
                dsIndemnizatii: {} as DataSource,
                dataGridRef: ref<DxDataGrid | null>(null),
                deleteConfirmationMessage: "Sigur doriți să ștergeți această înregistrare?",
                addPopupVisible: false,
                newIndemnizatie: {
                    cod: '',
                    name: '',
                    procent: null,
                    prevMo: null,
                    maxDays: null,
                    fond: '',
                    Grup: '',
                    GrupCod: '',
                },
                addButtonOptions: {
                    type: "success", 
                    text: "Salvează", 
                    stylingMode: "contained",
                    onClick: () => {
                        this.onSaveAdd()
                    }
                },
                saveButtonOptions: {
                    type: "success", 
                    text: "Salvează", 
                    stylingMode: "contained",
                    onClick: () => {
                        this.onSaveEdit()
                    }
                },
                closeButtonOptions: {
                    type: "danger", 
                    text: "Închide", 
                    stylingMode: "contained",
                    onClick: () => {
                        this.onCloseAdd()
                    }
                },
                dangerButtonOptions: {
                    type: "danger", 
                    text: "Închide", 
                    stylingMode: "contained",
                    onClick: () => {
                        this.closeEditPopup()
                    }
                },
                monthOptions: [
                    { id: 1, text: 'Ianuarie' },
                    { id: 2, text: 'Februarie' },
                    { id: 3, text: 'Martie' },
                    { id: 4, text: 'Aprilie' },
                    { id: 5, text: 'Mai' },
                    { id: 6, text: 'Iunie' },
                    { id: 7, text: 'Iulie' },
                    { id: 8, text: 'August' },
                    { id: 9, text: 'Septembrie' },
                    { id: 10, text: 'Octombrie' },
                    { id: 11, text: 'Noiembrie' },
                    { id: 12, text: 'Decembrie'}
                ],
                fondOptions: [
                    { id: 'B', text: 'BASS/FNUASS' },
                    { id: 'F', text: 'FAAMBP' }
                ],
                numberBoxOptions: {
                    min: 0,
                    step: 1,
                    showSpinButtons: true,
                    showClearButton: true,
                    height: 50
                },
                numberBoxProcentOptions: {
                    min: 0,
                    step: 1,
                    max: 100,
                    showSpinButtons: true,
                    showClearButton: true,
                    height: 50
                },
            }
        },
        mounted() {
            this.dsIndemnizatii = new DataSource({
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_ResurseUmaneOdata + `PER_Sicknesses`,
                    key: 'Id',
                    keyType: "Guid",
                    version: 4,
                    beforeSend: (e: any) => {
                        e.headers = {
                            "Content-Type": "application/json",
                            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
                        };
                    },
                },
            })
            this.dataGridRef = this.$refs.dataGridRef as DxDataGrid;
            this.setDeleteConfirmationMessage()
        },
        methods: {
            setDeleteConfirmationMessage() {
                const dataGrid = this.$refs.dataGridRef?.instance;
                dataGrid.option('editing', {
                    allowUpdating: true,
                    allowDeleting: true,
                    mode: 'popup',
                    texts: {
                        confirmDeleteMessage: this.deleteConfirmationMessage,
                        confirmDeleteTitle: "Confirmare Ștergere",
                    }
                });
            },
            onRefreshClick() {
                const gridInstance = this.dataGridRef?.instance;
                if (gridInstance) {
                    gridInstance.refresh();
                    notify("Datele au fost actualizate cu succes!", "success", 3000);
                }
            },
            closeEditPopup() {
                this.dataGridRef?.instance?.cancelEditData();
            },
            async onSaveEdit() {
                const gridInstance = this.dataGridRef?.instance;
                if (!gridInstance) {
                    notify('Eroare: Grila nu este încărcată.', 'error', 2000);
                    return; 
                }
                try {
                    gridInstance.saveEditData()
                    notify('Datele au fost salvate cu succes!', 'success', 2000);
                } catch (error: any) {
                    console.error("Eroare la salvarea editării:", error);
                }
            },
            onAddClick() {
                this.addPopupVisible = true
            },
            onCloseAdd() {
                this.addPopupVisible = false
                this.newIndemnizatie.cod = ''
                this.newIndemnizatie.name = ''
                this.newIndemnizatie.procent = null
                this.newIndemnizatie.prevMo = null
                this.newIndemnizatie.maxDays = null
                this.newIndemnizatie.fond = ''
                this.newIndemnizatie.Grup = ''
                this.newIndemnizatie.GrupCod = ''
            },
            onCodValueChanged(e: any) {
                this.newIndemnizatie.cod = e.value
            },
            onNumeValueChanged(e: any) {
                this.newIndemnizatie.name = e.value
            },
            onProcentValueChanged(e: any) {
                this.newIndemnizatie.procent = e.value
            },
            onMonthValueChanged(e: any) {
                this.newIndemnizatie.prevMo = e.value
            },
            onMaxDaysValueChanged(e: any) {
                this.newIndemnizatie.maxDays = e.value
            },
            onFondValueChanged(e: any) {
                this.newIndemnizatie.fond = e.value
            },
            onGrupValueChanged(e: any) {
                this.newIndemnizatie.Grup = e.value
            },
            onGrupCodValueChanged(e: any) {
                this.newIndemnizatie.GrupCod = e.value
            },
            onSaveAdd() {
                if (this.newIndemnizatie.cod.trim() === "" || !this.newIndemnizatie.cod) {
                    notify("Vă rog să completați câmpul obligatoriu 'Cod'!", "error", 3000)
                    return
                }

                if (this.newIndemnizatie.name.trim() === "" || !this.newIndemnizatie.name) {
                    notify("Vă rog să completați câmpul obligatoriu 'Nume'!", "error", 3000)
                    return
                }

                if (!this.newIndemnizatie.procent) {
                    notify("Vă rog să completați câmpul obligatoriu 'Procent'!", "error", 3000)
                    return
                }

                if (!this.newIndemnizatie.prevMo) {
                    notify("Vă rog să completați câmpul obligatoriu 'Luna Precedenta'!", "error", 3000)
                    return
                }

                if (!this.newIndemnizatie.fond) {
                    notify("Vă rog să completați câmpul obligatoriu 'Fond'!", "error", 3000)
                    return
                }

                if (!this.newIndemnizatie.maxDays) {
                    notify("Vă rog să completați câmpul obligatoriu 'Numar de Zile'!", "error", 3000)
                    return
                }

                if (this.newIndemnizatie.Grup.trim() === "" || !this.newIndemnizatie.Grup) {
                    notify("Vă rog să completați câmpul obligatoriu 'Grup'!", "error", 3000)
                    return
                }

                if (this.newIndemnizatie.GrupCod.trim() === "" || !this.newIndemnizatie.GrupCod) {
                    notify("Vă rog să completați câmpul obligatoriu 'Cod Grup'!", "error", 3000)
                    return
                }

                PER_Sicknesses.save(this.newIndemnizatie).then((ind) => {
                    this.addPopupVisible = false
                    notify('Datele au fost salvate cu succes!', 'success', 2000)
                    this.newIndemnizatie = {
                        cod: '',
                        name: '',
                        procent: null,
                        prevMo: null,
                        maxDays: null,
                        fond: '',
                        Grup: '',
                        GrupCod: '',
                    }
                    this.onRefreshClick()
                }).catch((error) => {
                    console.error(error)
                })
            }
        }
    })
</script>